module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAFo9M/3AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAATdJREFUeNpiYACCVatW/YcQQAAQQCBGAgMyAAggLCKokgIAAQRj/Afi/TCOApKK/+haHJiAxHkksX6AAGKEyrwHUo5hYWEXkFSDFAZimoNqZAATkD7AgBv4MyK57D7YSAaGD0AcD8QGQCsNAQKIEck4kD8coNxEoOQCuL/QXA4Te4/dswhFBqBwZILaiwGgXp4PUvAAjy8YQAry8cgfAIcYPFpQ3QB2OCMSB2TnQiAGKV4PxIpAdzwACDDkcFCAShgAMSgMNkIDjQGqyR+IE6AGBYI0o9vAAI3QD/g8BXXufmhIGDJCY+ABkJPIQAIA6psPpBRYoNHnyEA6AIXHfiYkP5IKBGDxBHL6elDUk+B8A2iAJyIn1/PQVJGInDOwaAT7HYgNUaIRLSPHIyVtRKoB+huezKEAAOskjvlTX78NAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/icon/yugaoff.png
// module id = kGLO
// module chunks = 1